module.exports = __webpack_public_path__ + "img/Pic_Support-2_c.4fce2082.jpg";